export const setItemInLocalStorageAndSendEvent = (key: string, newValue: string) => {
  const oldValue = localStorage.getItem(key);
  localStorage.setItem(key, newValue);
  window.dispatchEvent(
    new StorageEvent('storage', {
      key,
      oldValue,
      newValue,
      storageArea: localStorage,
      url: window.location.href,
    }),
  );
};

export const removeItemInLocalStorageAndSendEvent = (key: string) => {
  const oldValue = localStorage.getItem(key);
  localStorage.removeItem(key);
  if (oldValue === undefined || oldValue == null) {
    return;
  }
  window.dispatchEvent(
    new StorageEvent('storage', {
      key,
      oldValue,
      newValue: undefined,
      storageArea: localStorage,
      url: window.location.href,
    }),
  );
};
